/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Status_ReadingInputs */

const en_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading metadata`)
};

const ar_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ قراءة البيانات الوصفية`)
};

const bn_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেটাডেটা পড়া হচ্ছে`)
};

const de_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten werden gelesen`)
};

const es_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo metadatos`)
};

const fr_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture des métadonnées`)
};

const pt_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo metadados`)
};

const zh_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取元数据`)
};

const tr_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta veriler okunuyor`)
};

const ru_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение метаданных`)
};

const pl_image_inspector_status_reading = /** @type {(inputs: Image_Inspector_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odczytywanie metadanych`)
};

/**
* | output |
* | --- |
* | "Reading metadata" |
*
* @param {Image_Inspector_Status_ReadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_status_reading = /** @type {((inputs?: Image_Inspector_Status_ReadingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Status_ReadingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_status_reading(inputs)
	if (locale === "bn") return bn_image_inspector_status_reading(inputs)
	if (locale === "de") return de_image_inspector_status_reading(inputs)
	if (locale === "es") return es_image_inspector_status_reading(inputs)
	if (locale === "fr") return fr_image_inspector_status_reading(inputs)
	if (locale === "pt") return pt_image_inspector_status_reading(inputs)
	if (locale === "zh") return zh_image_inspector_status_reading(inputs)
	if (locale === "tr") return tr_image_inspector_status_reading(inputs)
	if (locale === "ru") return ru_image_inspector_status_reading(inputs)
	if (locale === "pl") return pl_image_inspector_status_reading(inputs)
	return en_image_inspector_status_reading(inputs)
});